import * as d3 from 'd3';
import { ComputationGraph } from '../graph/types';
import { layoutGraph } from '../graph/layout';
import { getThemeColors } from './theme';
import { createZoom, fitToView, ZoomContainer } from './zoom';
import { defineArrowMarker, renderEdges } from './edges';
import { renderNodes } from './nodes';

export class GraphRenderer {
  private zoom: ZoomContainer;
  private graphGroup: d3.Selection<SVGGElement, unknown, null, undefined>;

  constructor(svg: SVGSVGElement) {
    this.zoom = createZoom(svg);
    this.graphGroup = this.zoom.wrapper.append('g').attr('class', 'graph-layer');
    defineArrowMarker(this.zoom.svg, getThemeColors());
  }

  render(graph: ComputationGraph): void {
    const layout = layoutGraph(graph);
    const colors = getThemeColors();
    const nodeMap = new Map(layout.nodes.map((n) => [n.id, n]));

    this.graphGroup.selectAll('*').remove();
    defineArrowMarker(this.zoom.svg, colors);

    renderEdges(this.graphGroup, layout.edges, nodeMap, colors);
    renderNodes(this.graphGroup, layout.nodes, colors);

    fitToView(this.zoom, layout.width, layout.height);
  }

  destroy(): void {
    this.zoom.svg.on('.zoom', null);
    this.zoom.svg.selectAll('*').remove();
  }
}
